import { ChathostRegistrationLabelTypes } from './typings';
import { IS_ACTIVE, IS_DISABLED, CHATHOST_REGISTRATION_LABEL, SELECTOR } from './constants';

import createBrowserInfoParameters from './helpers/get-browser-info';
import validateFormData from './forms/chathost-registration';
import TestimonialsSlider from './features/testimonials-slider';

const validateCHRegistrationForm = (): void => {
    const registrationForm = document.querySelector<HTMLFormElement>('#registerChathostForm');
    const testimonialsSlider = document.querySelector<HTMLDivElement>('.js-testimonials');

    if (registrationForm) {
        setActiveRegistrationNavItem(registrationForm);
        validateFormData(registrationForm);
        createBrowserInfoParameters('#registerChathostForm', 'register');
    }

    if (testimonialsSlider) {
        new TestimonialsSlider(testimonialsSlider);
    }
};

const setActiveRegistrationNavItem = (form: HTMLFormElement): void => {
    const registrationNavigation = form.querySelector<HTMLDivElement>('.js-ch-reg__nav');
    const navigationItems = registrationNavigation?.querySelectorAll<HTMLDivElement>('.js-ch-reg__nav-item');

    navigationItems?.forEach((navigationItem: HTMLDivElement) => {
        navigationItem.addEventListener('click', (e: Event) => {
            e.preventDefault();

            const noteID: string | undefined = navigationItem.dataset.note;
            const label: ChathostRegistrationLabelTypes | undefined = navigationItem.dataset.label as ChathostRegistrationLabelTypes;

            removeActiveClassFromNavigationItems(navigationItems);
            navigationItem.classList.add(IS_ACTIVE);
            navigationItem.querySelector<HTMLInputElement>('[type=radio]')?.setAttribute('checked', 'checked');

            if (noteID) {
                showNote(form, noteID);
            }

            if (label) {
                setFormLabelVisibility(label, form);
            }
        });
    });

    isFirstAccount(form);
};

const removeActiveClassFromNavigationItems = (navigationItems: NodeListOf<HTMLDivElement>): void => {
    navigationItems.forEach((navigationItem: HTMLDivElement) => {
        navigationItem.classList.remove(IS_ACTIVE);
        navigationItem.querySelector<HTMLInputElement>('[type=radio]')?.removeAttribute('checked');
    });
};

const setFormLabelVisibility = (label: ChathostRegistrationLabelTypes, form: HTMLFormElement): void => {
    const firstAccount = form.querySelector<HTMLSelectElement>(SELECTOR.FIRST_ACCOUNT_SELECTOR);
    let hideFormLabelsList;
    let showFormLabelsList;
    let isSubmitDisabled = false;

    switch (label) {
        case CHATHOST_REGISTRATION_LABEL.STUDIO:
            hideFormLabelsList = form.querySelectorAll<HTMLSpanElement>('#JoinStA2, #JoinStB2, #JoinStC2');
            showFormLabelsList = form.querySelectorAll<HTMLSpanElement>('#studioAccountDetails, #JoinStA1, #JoinStB1, #JoinStC1');
            isSubmitDisabled = false;
            break;
        case CHATHOST_REGISTRATION_LABEL.EXISTING_STUDIO:
            hideFormLabelsList = form.querySelectorAll<HTMLSpanElement>('#JoinStA1, #JoinStB1, #JoinStC1');
            showFormLabelsList = form.querySelectorAll<HTMLSpanElement>('#studioAccountDetails, #JoinStA2, #JoinStB2, #JoinStC2');
            isSubmitDisabled = false;
            break;
        case CHATHOST_REGISTRATION_LABEL.NEW_ACCOUNT:
            hideFormLabelsList = form.querySelectorAll<HTMLSpanElement>('#studioAccountDetails, #JoinStA2, #JoinStB2, #JoinStC2, #JoinStA1, #JoinStB1, #JoinStC1');
            form.studioScreenNameID.value = '';
            form.studioPassword.value = '';

            if (firstAccount?.value === '2') {
                isSubmitDisabled = true;
            }

            break;
    }

    hideFormLabelsList?.forEach((formLabel: HTMLSpanElement) => {
        formLabel.style.display = 'none';
    });

    showFormLabelsList?.forEach((formLabel: HTMLSpanElement) => {
        formLabel.style.display = '';
    });

    setSubmitDisabled(form, isSubmitDisabled);
};

const setSubmitDisabled = (form: HTMLFormElement, isSubmitDisabled: boolean): void => {
    const submitButton = form.querySelector<HTMLButtonElement>('.js-create-account');

    if (isSubmitDisabled) {
        submitButton?.setAttribute('disabled', 'disabled');
        submitButton?.classList.add(IS_DISABLED);
    } else {
        submitButton?.removeAttribute('disabled');
        submitButton?.classList.remove(IS_DISABLED);
    }
};

const isFirstAccount = (form: HTMLFormElement): void => {
    const firstAccount = form.querySelector<HTMLSelectElement>(SELECTOR.FIRST_ACCOUNT_SELECTOR);
    const accountWarningMaximum = form.querySelector<HTMLDivElement>('.js-accCountWarningM');

    if (firstAccount && accountWarningMaximum) {
        firstAccount?.addEventListener('change', () => {
            const firstAccountValue: boolean = firstAccount.value === '2';
            accountWarningMaximum.style.display = firstAccountValue ? '' : 'none';
            setSubmitDisabled(form, firstAccountValue);
        });
    }
};

const showNote = (form: HTMLFormElement, note: string): void => {
    const noteID: number = parseInt(note, 10);
    const accountWarningGeneral = form.querySelector<HTMLDivElement>('.js-accCountWarning');
    const accountWarningStudio = form.querySelector<HTMLDivElement>('.js-accCountWarningST');
    const accountWarningMaximum = form.querySelector<HTMLDivElement>('.js-accCountWarningM');
    const firstAccount = form.querySelector<HTMLSelectElement>(SELECTOR.FIRST_ACCOUNT_SELECTOR);

    if (accountWarningGeneral && accountWarningStudio && accountWarningMaximum) {
        accountWarningGeneral.style.display = 'none';
        accountWarningStudio.style.display = 'none';
        accountWarningMaximum.style.display = 'none';

        if (noteID === 0) {
            accountWarningGeneral.style.display = '';
            accountWarningMaximum.style.display = firstAccount?.value === '2' ? '' : 'none';
        }

        if (noteID === 2) {
            accountWarningStudio.style.display = '';
        }
    }
};

validateCHRegistrationForm();
